import { Theme } from "src/app/interfaces/theme.model";
const lonaguiDefaults = { promoImg: "url(assets/images/promo_3.png)" };

export const LonaguiTheme: Theme = {
  name: "lonagui",
  useGateway: true,
  showTcktVerification: false,
  properties: {
    //-------------------------  header-----------------------------
    "--app-background-header": "#fff",
    "--app-background-base": "#fff",
    "--app-background-body": "#009d48",
    "--app-background-turf-home": "#f2f2f2",
    "--app-background-footer": "#037b3a",
    "--app-background-left-menu": "#037b3a",
    "--app-background-right-menu": "",
    "--app-background-nav": "#027835",
    "--app-background-nav-hover": "#009d48",
    "--app-background-nav-border-bottom": "#fcd016",
    "--app-background-main": "rgb(242, 242, 242)",
    "--app-background-home": "#037b3a",
    "--app-color-tournament": "#154e2b",
    "--app-color-heading": "#77777a",
    "--app-color-header": "#77777a",
    "--app-color-body": "#5d5d5d",
    "--app-color-footer": "#eb862c",
    "--app-color-nav": "#fff",
    "--app-color-main": "#212121",
    "--app-color-forgot_pw": "#027835",
    "--app-background-primary-tint": "",
    "--app-background-input-primary": "#dedede",
    "--app-background-secondary-tint": "#027835",

    //-------------------------  owl calendar-----------------------------
    "--app-background-calendar-header": "#fa7f22",
    //-------------------------  side menu-----------------------------
    "--app-background-side-menu": "#e6e6e6",
    "--app-color-side-menu": "#fff",
    // lexique
    // "--app-color-lexique": "#403939",
    // "--app-background-lexique": "#fcd016",
    "--app-color-lexique": "#fff",
    "--app-background-lexique": "#fa7f22",
    "--app-background-cmtJr": "#fa7f22",
    "--app-color-cmtJr": "#fff",

    // promotions
    "--app-color-promotions": "#fff",
    "--app-background-promotions": "#027835",
    "--app-background-border-promotions": "#fa7f22",

    // cagnottes
    "--app-color-cagnotte-header": "#fff",
    "--app-background-cagnotte-header": "#fa7f22",
    // comment jouer
    //-------------------------  second nav-----------------------------
    "--app-background-second-nav": "#027835",
    "--app-background-second-nav-hover": "#009d48",
    "--app-color-second-nav": "#fff",
    "--app-background-second-nav-selected": "#fff",
    "--app-color-second-nav-selected": "#027835",
    "--app-background-border-second-nav-selected": "#027835",
    "--app-color-second-nav-course": "#77777a",

    //-------------------------  rapports-----------------------------
    "--app-color-rapport": "#77777a",
    "--app-background-rapport": "#009d48",
    "--app-background-rapport-header-border": "#027835",

    //-------------------------  top races-----------------------------
    "--app-color-top-race-RN": "#027835",
    "--app-color-top-race-CN": "#027835",
    "--app-color-top-race-time": "#b9b8ba",
    "--app-color-top-race-time-up": "#fcd016",
    "--app-background-top-race": "transparent",
    //-------------------------  meetings-----------------------------
    "--app-color-meeting-link": "#77777a",
    "--app-background-meeting-link": "#fff",
    "--app-color-meeting-link-selected": "#fff",
    "--app-background-meeting-link-selected": "#027835",
    "--app-background-meeting-link-borders": "#027835",

    //-------------------------  race details-----------------------------
    "--app-color-race-time": "#77777a",
    //-------------------------  race list-----------------------------
    "--app-color-table-header": "#77777a",
    "--app-color-table-header-border-left": "#027835",
    "--app-background-wrap-race": "#fff",
    "--app-color-table-headings": "",
    "--app-color-table": "#77777a",
    "--app-color-table-subdetails": "#77777a",
    "--app-color-table-numbers": "#77777a",
    "--app-color-table-open": "#fff",
    "--app-color-table-content-open": "#77777a",
    "--app-background-table-open": "#5d5d5d",
    //-------------------------  registration-----------------------------
    "--app-color-registration": "#fff",
    "--app-background-registration": "#027835",
    "--app-background-registration-input": "#dedede",
    "--app-color-registration-input": "#000",
    "--app-background-registration-input-border": "#fff",
    "--app-color-registration-validation-error": "#fcd016",

    //-------------------------  footer-----------------------------
    "--app-color-footer-heading-1": "#00ff75",
    "--app-color-footer-body": "",
    // reset password
    "--app-color-resetpw-header": "#027835",
    //-------------------------  transactions history and account -----------------------------
    "--app-background-transactions": "#009d48",
    "--app-background-profile-body": "#027835",
    "--app-color-transaction-tab-secondary": "#f8bd31",
    "--app-color-transaction-tab-primary": "#fff",
    "--app-color-profile-section-activeheader": "#f8bd31",
    "--app-background-profile-header": "#027835",
    "--app-background-profile-header-border": "#009d48",
    "--app-background-profile-section-header": "#176334",
    "--app-color-profile-section-header": "#fff",
    "--app-color-profile-input": "#fff",
    "--app-color-profile-input-placeholder": "#eee",
    "--app-background-profile-input": "#027835",
    "--app-color-profile-input-border": "#176334",
    "--app-color-profile-input-lable": "#64c388",
    "--app-background-transactions-body": "#027835",
    "--app-color-transactions-header": "#64c388",
    "--app-color-transactions-header-input-border": "#64c388",
    "--app-color-transactions-header-input-lable": "#64c388",
    "--app-color-transactions-header-input": "#fff",

    "--app-background-transactions-tabs": "#027835",
    "--app-color-accounts": "#dedede",
    "--app-background-row-even": "#fff",
    "--app-background-row-odd": "#dedede",
    "--app-color-transactions-container-color": "#154e2b",
    "--app-background-transaction-methods": "#009d48",
    "--app-background-active-trans-method":
      "linear-gradient(90deg  , #fcd016 -1.5%, #009d48 101.5%)",
    "--app-color-methods-border-left": "#009d48",
    "--app-color-border-acc-input-focus": "#009d48",

    //-------------------------  betslip-----------------------------
    "--app-color-betslip-header": "#fff",
    "--app-background-betslip-header": "#027835",
    "--app-background-betSummary": "#fcd016",
    "--app-color-betSummary": "#403939",
    "--app-color-yello-odd": "#fcd016",
    "--app-color-background-dropdown": "#027835",
    "--app-color-betslip": "#027835",
    "--app-background-betslip": "#fff",
    "--app-color-betslip-amount": "#037b3a",
    "--app-color-betslip-meeting": "#777777",
    //-------------------------  betslip-----------------------------
    "--app-background-checkbox-input-unchecked": "#ffffffa4",
    "--app-color-checkbox-input-border-unchecked": "#777676e5",

    "--app-background-checkbox-input": "#fcd016",
    "--app-color-checkbox-input-border": "#fff",
    //-------------------------  account modal -----------------------------

    "--app-background-modal-window": "#027835",
    "--app-color-modal-window": "#fff",

    //-------------------------  buttons-----------------------------
    "--app-color-button-primary": "#fff",
    "--app-background-button-primary": "#027835",
    "--app-color-button-secondary": "#fff",
    "--app-background-button-secondary": "#fcd016",
    "--app-color-bet-button": "#5d5d5d",
    "--app-background-bet-button": "#fcd016",
    "--app-color-rapport-button": "#77777a",
    "--app-background-rapport-button-border": "#b9b8ba",
    "--app-background-rapport-button": "#fff",
    "--app-color-betSlip-button": "#fff",
    "--app-background-betSlip-button": "#b9b8ba",
    "--app-color-coef-button": "#fff",
    "--app-background-coef-button": "#fcd016",
    //-------------------------  Account Modal-----------------------------
    "--app-background-main-modal": "#027835",
    "--app-color-main-modal": "#efd7c2",
    "--app-color-main-modal-border": "#009d48",

    // -----------------------------faq -----------------------------------
    "--app-color-faq-header": "#009d48",

    // -----------------------------default imgs --------------------------
    "--img-default-promo": lonaguiDefaults.promoImg,
  },
  country: "GN",
  contact:{
    tel: '+225 07 07 07 18 89',
    email: 'hotline@lonaci.ci',
    fax: '+225 01 01 51 44 00',
    addresse: 'e'
  },
  betOptions: {
    version: '4.3'
  }

};